import React, { useEffect } from 'react';
import { Modal, Button } from 'gatorcomponents';
import * as Styles from './VpsWelcomeModal.styles';
import Snappy from './media/snappy-laptop.svg';
import useLocale from '@/hooks/useLocale';
import { vpsOciActions } from '@/redux/modules';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

const VpsWelcomeModal = ({
  onClose,
  onStartTour,
  tourSession,
  testId = 'vpsoci-welcome-modal',
}) => {
  const { productDetails: productDetailsLocale } = useLocale();
  const { vpsOci: locale } = productDetailsLocale;
  const dispatch = useDispatch();

  const { id: productId } = useParams();

  const handleStartTour = () => {
    onStartTour && onStartTour();
  };

  useEffect(() => {
    dispatch(vpsOciActions.tour.saveStep({ step: 'tour_welcome', hostingId: productId, session: tourSession }));
  }, [dispatch, tourSession, productId]);

  return (
    <Modal
      onClose={onClose}
      maxWidth={800}
      title={locale.welcomeModal.title}
      testId={testId}
    >
      <Styles.Container>
        <Styles.ContentWrapper>
          <Styles.TextContent>
            <Styles.Description data-testid={`${testId}-description`}>
              {locale.welcomeModal.description}
            </Styles.Description>
          </Styles.TextContent>
          <Styles.ImageWrapper data-testid={`${testId}-image-wrapper`}>
            <Styles.SnappyImage src={Snappy} alt="Snappy" />
          </Styles.ImageWrapper>
        </Styles.ContentWrapper>
        <Styles.Actions>
          <Button
            label={locale.welcomeModal.buttonLabel}
            variant="primary"
            size="large"
            onClick={handleStartTour}
            testId={`${testId}-start-tour-button`}
          />
        </Styles.Actions>
      </Styles.Container>
    </Modal>
  );
};

export default VpsWelcomeModal;
